export default "__VITE_ASSET__CpDYBs1h__"